module.exports = __webpack_public_path__ + "img/ntpp3-1.c4d14b4a.png";